module.exports = __webpack_public_path__ + "media/images/apple-icon-72x72-a3fd994d.png";